<template>
    <AppBase>
        <v-card flat>
            <v-card-title class="justify-center">Resources</v-card-title>
            <v-card-subtitle>As you go through the MyPEEPS activities, you'll learn important information that you may want to review later. These will be added to Resources as you complete your journey.</v-card-subtitle>
            <v-divider v-if="hasBottomLine"></v-divider>
            <v-card-subtitle v-if="hasBottomLine">My BottomLine</v-card-subtitle>
            <v-card-text v-if="hasBottomLine">
                <div class="bottom-line">
                    <div v-for="statement in bottomLineStatements" :key="statement.id">
                        <label class="bottomline-statement" v-html="statement.statement"></label>
                        <label class="bottomline-response">{{ bottomLine(statement.id) }}</label>
                    </div>
                </div>
            </v-card-text>
            <v-divider v-if="hasBullsI"></v-divider>
            <v-card-subtitle v-if="hasBullsI">My Bulls-I</v-card-subtitle>
            <v-card-text v-if="hasBullsI">
                <my-bulls-i></my-bulls-i>
            </v-card-text>
            <v-divider v-if="hasDrugsAndAlcohol"></v-divider>
            <v-card-subtitle v-if="hasDrugsAndAlcohol">Drugs/Alcohol Links</v-card-subtitle>
            <v-card-text v-if="hasDrugsAndAlcohol">
                <ul>
                    <li v-for="(resource, index) in drugsAndAlcoholResources" :key="index">
                        {{ resource.topic }}
                        <external-link :href="resource.url" target="_blank">{{ resource.url }}</external-link>
                    </li>
                </ul>
            </v-card-text>
            <v-divider v-if="hasHIV"></v-divider>
            <v-card-subtitle v-if="hasHIV">HIV Links</v-card-subtitle>
            <v-card-text v-if="hasHIV">
                <ul>
                    <li v-for="(resource, index) in hivResources" :key="index">
                        {{ resource.topic }}
                        <external-link :href="resource.url" target="_blank">{{ resource.url }}</external-link>
                    </li>
                </ul>
            </v-card-text>
        </v-card>
    </AppBase>
</template>

<script>
    import AppBase from '@/components/AppBase';
    import { get } from 'vuex-pathify';
    import { find, filter, sortBy, findLast } from 'lodash';

    export default {
        name: 'Resources',
        components: { AppBase },
        data: () => ({
            //
        }),
        methods: {
            bottomLine(id) {
                // need to get the most current bottomline answer for each prompt; this could be from any
                // of the bottomline modules, and theoretically some could be incomplete (although
                // this should never happen in production).
                let el = findLast(this.myBottomLine, (e) => {
                    return e.myBottomLine[id].response != null;
                });

                return this.bottomLineChoices[el.myBottomLine[id].response].choice;
            }
        },
        computed: {
            completedModules: get('completed'),
            hasBottomLine() {
                // there are multiple BottomLine modules, but will show if they have
                // made it past the first one (module 2)
                if (
                    find(this.completedModules, (o) => {
                        return o.id === 2;
                    })
                )
                    return true;
                else return false;
            },
            hasBullsI() {
                // Bulls-I is module 4
                if (
                    find(this.completedModules, (o) => {
                        return o.id === 4;
                    })
                )
                    return true;
                else return false;
            },
            hasDrugsAndAlcohol() {
                // if any of the drugs and alcohol resources are unlocked, show this section.
                // but only show links to those already unlocked
                return this.drugsAndAlcoholResources.length > 0;
            },
            hasHIV() {
                // if any of the HIV resources are unlocked, show this section.
                // but only show links to those already unlocked
                return this.hivResources.length > 0;
            },
            myBottomLine() {
                return sortBy(this.$store.get('bottomLine'), 'module');
            },
            bottomLineStatements: get('content@bottomLineStatements'),
            bottomLineChoices: get('content@bottomLineChoices'),
            myBullsI: get('myBullsI'),
            drugsAndAlcoholResources() {
                return filter(this.$store.get(`resources`), (o) => {
                    return o.category === 'Drugs and Alcohol' && o.unlocked;
                });
            },
            hivResources() {
                return filter(this.$store.get(`resources`), (o) => {
                    return o.category === 'HIV' && o.unlocked;
                });
            }
        }
    };
</script>

<style scoped>
    .bottom-line {
        width: 100%;
        background-color: var(--v-primary-base);
        padding: 5px;
    }
    .bottomline-statement {
        color: white;
        display: block;
        padding: 5px;
        width: 100%;
    }
    .bottomline-response {
        background-color: white;
        display: block;
        width: 100%;
        padding-left: 5px;
    }
</style>
